import { isNil, isString } from "@/common/helpers/lang";

import type { Media as MediaType } from "@/payload-types";

export const isMedia = <Media extends MediaType>(image?: Media | string | number | null): image is Media =>
  !isNil(image) && typeof image !== "string" && typeof image !== "number" && isString(image.url);
